// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 385) return "static/chunks/sanity-f0fd5c0b00a96cc1.js";
	// return url for filenames based on template
	return "static/chunks/" + "a4634e51" + "." + "b3e6f41dd1dce901" + ".js";
};